import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Skeleton, Divider } from '@mui/material';
import { csn } from '@one-vision/utils';
import { useStyles } from './dz-update-tech-dialog.styles';
export const DzSkeletonUpdateTechDialog = ({ zendesk }) => {
    const classes = useStyles();
    return (_jsxs(_Fragment, { children: [_jsx(Skeleton, { animation: "wave", variant: "text", height: 50, width: "40%", className: classes.skeletonMargin }), _jsx(Skeleton, { animation: "wave", variant: "rectangular", height: 300 }), _jsx(Divider, { className: csn(classes.divider, [classes.dividerZen, zendesk]) })] }));
};
